import { c as _c } from "react/compiler-runtime";
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { PianoIdentity } from '../../layout/PianoIdentity';
import { PrintButton } from '../../layout/PrintButton';
import { DesignStepsBar } from '@/components/design/steps/DesignStepsBar';
import { useAnalyzedKeyboard } from '../../../hooks/keyboard/use-analyzed-keyboard';
import { usePrintLandscape } from '@/hooks/use-print-page-size';
import { useTranslation } from '@/hooks/use-translation';
import { WippenSupportSpringsDesign } from '@/components/design/wippen-support-springs/WippenSupportSpringsDesign';
export const DesignWippenSupportSpringsPage = () => {
  const $ = _c(14);
  const analyzedKeyboard = useAnalyzedKeyboard();
  const {
    t
  } = useTranslation();
  usePrintLandscape();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PianoIdentity /><PrintButton /></>;
    t1 = <DesignStepsBar currentStepId="springs" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <em className="ptl-accent">Springs</em>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== t) {
    t3 = <Trans t={t} i18nKey="Wippen Support <1>Springs</1>">Wippen Support {t2}</Trans>;
    t4 = t("If your wippens carry support springs, work them into your design to reduce the lead needed in the keys.");
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <PageHeading title={t3} lede={t4} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== analyzedKeyboard) {
    t6 = <WippenSupportSpringsDesign analyzedKeyboard={analyzedKeyboard} />;
    $[9] = analyzedKeyboard;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <MainLayout headerRight={t0}>{t1}{t5}{t6}</MainLayout>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};